import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { PendingInvite } from '@/api/types/backend-dto-types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useUpdatePendingInvite = ({ matterId }: { matterId: string }) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<PendingInvite, Error, { inviteId: string; roleId: string | null }>(
    async ({ inviteId, roleId }) => {
      const response = await fetch(
        `${APIBaseChronos}/api/matters/${matterId}/pending-invites/${inviteId}`,
        getFetchConfig({ method: FetchMethod.PATCH, data: { roleId } }),
      );
      if (!response.ok) throw new Error('Failed to update pending invite');
      return response.json();
    },
    {
      onSuccess: () => queryClient.invalidateQueries([QueryEntity.PendingInvites, { matterId }]),
    },
  );
};
